import { TextArea } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import { Request } from "../../../models/Request";

const MAX_LENGTH = 1000;

interface IProps {
  request: Request;
  handleUpdate: (request: Request) => void;
}

export const ParentRemark = ({ request, handleUpdate }: IProps) => {
  const { t } = useTranslation();

  const handleParentRemarkChange = (value: string) => {
    handleUpdate({ ...request, parentRemark: value });
  };

  return (
    <div className="mb-3">
      <TextArea
        label={t("request.parentRemark")}
        ariaLabel={t("request.parentRemark")}
        value={request.parentRemark || ""}
        onChange={(e) => handleParentRemarkChange(e.target.value)}
        maxLength={MAX_LENGTH}
        rows={4}
        helperText={`${(request.parentRemark || "").length} / ${MAX_LENGTH}`}
      />
    </div>
  );
};
